import { Flex } from 'antd';
import HeaderCard from 'components/HeaderCard';

const PageHeaderLayout = ({
  children,
  pageConfig,
  renderFilters,
}: {
  children: React.ReactNode;
  pageConfig: {
    header: string;
    description: string;
  };
  renderFilters?: () => React.ReactNode;
}) => {
  return (
    <Flex vertical gap={16}>
      <HeaderCard
        headerLabel={pageConfig.header}
        headerInfo={pageConfig.description}
        filters={renderFilters?.()}
      />
      <Flex gap={32} vertical className="hotcash-table-container">
        {children}
      </Flex>
    </Flex>
  );
};

export default PageHeaderLayout;
